import React from 'react';
import { PENDING } from 'types/session';
import Request from './Request';

export default function PlannedRequests() {
	return <Request status={[PENDING]} mode="planned" />;
}
